import { Field, Form, Formik } from "formik";
import { checkoutvalidation } from "../../../../Validation/Checkout";
import { gettoken, getshipping, shippinfidstore, shippingidremove } from "../../../../Localstorage/Store";
import { useSelector } from "react-redux";
import { getCode } from "country-list";
import { useRef, useState } from "react";
import { FaCheck, FaEdit } from "react-icons/fa";
import { usePutUpdateAddressMutation, usePostCreateAddressMutation } from "../../../../store/api/addressapi";
import axios from "axios";

const EditAddress = ({ address, onAddressChange, addressToEdit }) => {
  const shippingid = getshipping();
  const closeEditBtn = useRef(null);
  const tokenvalue = gettoken();
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [shipaddress, setshipaddress] = useState(false);
  const [shippingaddressopen, setshippingaddressopen] = useState(false);
  const [editStatus, setEditStatus] = useState(false);
  const [cityna, setcityna] = useState("");

  // API mutations
  const [updateAddress] = usePutUpdateAddressMutation();
  const [createAddress] = usePostCreateAddressMutation();

  const toggleShipping = () => {
    setshipaddress(!shipaddress);
    if(shipaddress == true){
        shippingidremove()
        address.refetch();
      }
  
  };

  const setShippingAddress = (id) => {
    shippinfidstore(id);
    address.refetch();
  };

   const removesh = () => {
    console.log("sdfghjkjhfd")
    shippingidremove();
    address.refetch();
  };

  const handleClose = () => {
    closeEditBtn.current?.click();
  };

  const editAddress = async (values, setFieldError) => {
    try {
      const newformdata = {
      "first_name":values.first_name,
      "last_name":values.last_name,
      "phone_number":`+91${values.mobile}`,
      "line1":values.address1,
      "line2":values.address2,
      "country":getCode(values.country),
      "state":values.state,
      "email":values.email,
      "line4":values.city,
      "address_type":values.address_type,
      "postcode":values.pincode
    }

console.log("ccccccccccccc",newformdata)
      const response = await updateAddress({
        id: addressToEdit.id,
        data: newformdata
      }).unwrap();

      if (response?.id) {
        setEditStatus(true);

        setTimeout(() => {
          onAddressChange(addressToEdit.id);
          setEditStatus(false);
          handleClose();
        }, 1500);
      }
    } catch (error) {
      console.error("Edit address error:", error);
      setFieldError("mobile", error?.data?.phone_number?.[0] || "Error updating address");
    }
  };

  const createShippingAddress = async (values, setFieldError) => {
    try {
      const formdata = new FormData();
      formdata.append("first_name", values.first_name);
      formdata.append("last_name", values.last_name);
      formdata.append("phone_number", `+91${values.mobile}`);
      formdata.append("line1", values.address1);
      formdata.append("line2", values.address2);
      formdata.append("country", getCode(values.country));
      formdata.append("state", values.state);
      formdata.append("email", values.email);
      formdata.append("line4", values.city);
      if (tokenvalue.msg == "Voucher login") {
        formdata.append("user", tokenvalue.user_id);
      } else {
        formdata.append("user", tokenvalue.id);
      }
      formdata.append("address_type", values.address_type);
      formdata.append("postcode", values.pincode);

      const response = await createAddress(formdata).unwrap();

      if (response?.id) {
          await address.refetch();
        setShippingAddress(response.id);
        setshippingaddressopen(false);
      }
    } catch (error) {
      console.error("Create shipping address error:", error);
      setFieldError("mobile", error?.data?.phone_number?.[0] || "Error creating address");
    }
  };
  


  const fetchStateAndCity = async (value, setFieldError, setFieldValue) => {
    if (value.length === 6) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/?postal_code=${value}`
        );

        if (response.data.city === "NA") {
          setFieldValue("city", "");
          setcityna("NA");
          setFieldError("city", "Please Enter Your City");
        } else {
          setFieldValue("city", response.data.city);
          setcityna("");
        }

        setFieldValue("state", response.data.state);
        const countryData = address.country.filter(
          item => item.printable_name === response.data.country.trim()
        );

        if (countryData.length > 0) {
          setFieldValue("country", countryData[0].printable_name);
          setFieldValue("countryurl", countryData[0].url);
        }
      } catch (error) {
        setFieldError("pincode", error.response?.data?.message || "Invalid pincode");
      }
    } else {
      setFieldValue("city", "");
      setFieldValue("state", "");
      setFieldValue("country", "");
      setFieldValue("countryurl", "");
    }
  };

  return (
    <>
      <button

        data-bs-toggle="modal"
        data-bs-target="#editAddressModal"
        style={{
          border: "none",
          outline: "none",
          backgroundColor: "#fff",
          padding: "3px 3px",
          color: `#${bgColor}`,
          width: "fit-content",
          fontWeight: 600,
        }}

      >
        <FaEdit
          style={{
            fontSize: "10px",
            position: "relative",
            top: "-1px",
            left: "2px",
          }}
        />{" "}
        Edit
      </button>
      <div className="modal fade" id="editAddressModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog" style={{ maxWidth: "785px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5">Edit Address</h1>
              <button
                type="button"
                ref={closeEditBtn}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body" style={{ maxHeight: "90vh", overflowX: "hidden" }}>
              <Formik
                initialValues={{
                  first_name: addressToEdit?.first_name || "",
                  last_name: addressToEdit?.last_name || "",
                  email: addressToEdit?.email || "",
                  mobile: addressToEdit?.phone_number?.replace('+91', '') || "",
                  address1: addressToEdit?.line1 || "",
                  address2: addressToEdit?.line2 || "",
                  country: addressToEdit?.country_printable_name || "",
                  state: addressToEdit?.state || "",
                  city: addressToEdit?.line4 || "",
                  pincode: addressToEdit?.postcode || "",
                  address_type: addressToEdit?.address_type || "HOME",
                }}
                validationSchema={checkoutvalidation}
                onSubmit={(values, { setFieldError }) => editAddress(values, setFieldError)}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, setFieldValue, setFieldError }) => (
                  <Form>
                    <div className="row check-out">
                      {/* Address Type */}
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Address Type
                          <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <div className="d-flex" style={{ gap: "10px" }}>
                          {["HOME", "OFFICE", "OTHER"].map(type => (
                            <div key={type}>
                              <label style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                <input
                                  type="radio"
                                  name="address_type"
                                  value={type}
                                  onChange={handleChange}
                                  checked={values.address_type === type}
                                />
                                {type}
                              </label>
                            </div>
                          ))}
                        </div>
                        {errors.address_type && touched.address_type && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.address_type}</p>
                        )}
                      </div>

                      {/* First Name */}
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                          First Name <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          type="text"
                          name="first_name"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your First Name"
                        />
                        {errors.first_name && touched.first_name && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.first_name}</p>
                        )}
                      </div>

                      {/* Last Name */}
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                          Last Name <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="last_name"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Last Name"
                        />
                        {errors.last_name && touched.last_name && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.last_name}</p>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Phone <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="mobile"
                          type="tel"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Mobile No"
                          onChange={(e) => {
                            setFieldValue("mobile", e.target.value.replace(/\D/g, ""));
                          }}
                        />
                        {errors.mobile && touched.mobile && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.mobile}</p>
                        )}
                      </div>

                      {/* Email */}
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Email Address <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Email Address"
                        />
                        {errors.email && touched.email && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.email}</p>
                        )}
                      </div>

                      {/* Address 1 */}
                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Address 1 <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="address1"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="House number and street name"
                        />
                        {errors.address1 && touched.address1 && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.address1}</p>
                        )}
                      </div>

                      {/* Address 2 */}
                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Address 2 <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="address2"
                          type="text"
                          className="form-control "
                          style={{ fontSize: "12px" }}
                          placeholder="Apartment, suite, unit etc."
                        />
                        {errors.address2 && touched.address2 && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.address2}</p>
                        )}
                      </div>

                      {/* Postal Code */}
                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Postal Code <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="pincode"
                          type="tel"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Pincode"
                          minLength={6}
                          maxLength={6}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9\ ]/gi, "");
                            setFieldValue("pincode", value);
                            fetchStateAndCity(value, setFieldError, setFieldValue);
                          }}
                        />
                        {errors.pincode && touched.pincode && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.pincode}</p>
                        )}
                      </div>

                      {/* City */}
                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          City <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="city"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your City"
                          readOnly={values.state && cityna !== "NA"}
                        />
                        {errors.city && touched.city && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.city}</p>
                        )}
                      </div>

                      {/* State */}
                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          State <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="state"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your State"
                          readOnly
                        />
                        {errors.state && touched.state && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.state}</p>
                        )}
                      </div>

                      {/* Country */}
                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Country <span style={{ color: "red", fontSize: "13px" }}> *</span>
                        </label>
                        <Field
                          name="country"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Country"
                          readOnly
                        />
                        <Field
                          name="countryurl"
                          type="hidden"
                          className="form-control"
                          readOnly
                        />
                        {errors.country && touched.country && (
                          <p style={{ color: "red",textAlign:'start' }}>{errors.country}</p>
                        )}
                      </div>

                      {/* Shipping Address Toggle */}
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 cht mb-0 d-flex align-items-center">
                        <div
                          style={{
                            height: "18px",
                            width: "18px",
                            background: shipaddress ? `#${bgColor}` : "#e9ecef",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "2px",
                            cursor: "pointer",
                            marginRight: "8px"
                          }}
                          onClick={toggleShipping}
                        >
                          {shipaddress && <FaCheck style={{ fontSize: "10px", color: "#fff" }} />}
                        </div>
                        <span onClick={toggleShipping} style={{ cursor: "pointer",color:"#000" }}>
                          SHIP TO A DIFFERENT ADDRESS?
                        </span>
                      </div>

                     











                      {/* Form Actions */}
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 mt-3">
                        <div className="d-flex justify-content-end gap-2">
                          <button
                            type="button"
                              style={{
                                fontSize: "12px",
                                background: "#bdbfc0",
                                color: "#000",
                              }}
                              className="btn-normal btn"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            style={{ fontSize: "12px", background: `#${bgColor}` }}
                              className="btn-normal btn"
                          >
                            Update
                          </button>
                        </div>
                      </div>

                      {/* Success Message */}
                      {editStatus && (
                        <div className="form-group col-md-12 col-sm-12 col-xs-12">
                          <div className="alert alert-success mb-0">
                            Address Updated Successfully
                          </div>
                        </div>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>

               {/* Shipping Address Section */}
                      {shipaddress && (
                        <div className="form-group col-md-12 col-sm-12 col-xs-12 cht mt-3">
                          {!shippingaddressopen ? (
                            <>
                              <div className="col-12 mb-3">
                                <h6
                                  style={{
                                    color: `#${textColor}`,
                                    cursor: "pointer",
                                    display: "inline-block",
                                    textAlign:'start',
                                    width:'100%'
                                  }}
                                  onClick={() => setshippingaddressopen(true)}
                                >
                                  + Add Shipping Address
                                </h6>
                              </div>

                              {/* List of existing addresses for shipping */}
                              <div className="row">
                              {address.list
                                .filter(item => item.id !== addressToEdit.id)
                                .map(item => (
                                  <div key={item.id} className="col-lg-6 mb-3">
                                    <div className="card">
                                      <div className="card-body">
                                        <h5 className="card-title acounttitle m-0" style={{textAlign:'start',paddingLeft:'32px',paddingBottom:'4px'}}>
                                          {item.first_name} {item.last_name}
                                          <span style={{ fontSize: "10px", color: "#8d9091" }}>
                                            ({item.address_type})
                                          </span>
                                        </h5>
                                        <div className="form-check" style={{ position: "relative" }}>
                                 
                                     {shippingid == item.id ? <input
                                            type="radio"
                                            name="shippingAddress"
                                            style={{ position: "absolute", top: "9px", left: "5px" }}
                                            onClick={() => removesh()}
                                            checked
                                          /> : <input
                                            type="radio"
                                            name="shippingAddress"
                                            style={{ position: "absolute", top: "9px", left: "5px" }}
                                            onChange={() => setShippingAddress(item.id)}
                                          
                                          />}     
                                          <div className="form-check-label " style={{paddingLeft:'15px'}}>
                                            <div className="number acounttitle" style={{color:'#000',fontSize:'12px',textAlign:'start',paddingLeft:'0px'}}>
                                              Mobile: <span style={{ fontSize: "12px",color:'#000' }}>{item.phone_number}</span>
                                            </div>
                                            <div className="small-text" style={{textAlign:'start',paddingLeft:'0px'}}>
                                              {[item.line1, item.line2, item.country_printable_name, item.state, `${item.line4}-${item.postcode}`]
                                                .filter(Boolean)
                                                .join(" ")}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                </div>
                            </>
                          ) : (
                             <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          mobile: "",
          address1: "",
          address2: "",
          country: "",
          state: "",
          city: "",
          pincode: "",
          address_type: "HOME",
        }}
        validationSchema={checkoutvalidation}
        onSubmit={(values, { setFieldError }) => {
          createShippingAddress(values, setFieldError);
        }}
      >
        {({ values, errors, touched, handleChange, setFieldValue }) => (
          <Form>
            <div className="row check-out">
              {/* Address Type */}
              <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Address Type
                  <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <div className="d-flex" style={{ gap: "10px" }}>
                  {["HOME", "OFFICE", "OTHER"].map(type => (
                    <div key={type}>
                      <label style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        <input
                          type="radio"
                          name="address_type"
                          value={type}
                          onChange={handleChange}
                          checked={values.address_type === type}
                        />
                        {type}
                      </label>
                    </div>
                  ))}
                </div>
                {errors.address_type && touched.address_type && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.address_type}</p>
                )}
              </div>

              {/* First Name */}
              <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                  First Name <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  type="text"
                  name="first_name"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your First Name"
                />
                {errors.first_name && touched.first_name && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.first_name}</p>
                )}
              </div>

              {/* Last Name */}
              <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                  Last Name <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="last_name"
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your Last Name"
                />
                {errors.last_name && touched.last_name && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.last_name}</p>
                )}
              </div>

              {/* Phone */}
              <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Phone <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="mobile"
                  type="tel"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your Mobile No"
                  onChange={(e) => {
                    setFieldValue("mobile", e.target.value.replace(/\D/g, ""));
                  }}
                />
                {errors.mobile && touched.mobile && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.mobile}</p>
                )}
              </div>

              {/* Email */}
              <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Email Address <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="email"
                  type="email"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your Email Address"
                />
                {errors.email && touched.email && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.email}</p>
                )}
              </div>

              {/* Address 1 */}
              <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Address 1 <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="address1"
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="House number and street name"
                />
                {errors.address1 && touched.address1 && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.address1}</p>
                )}
              </div>

              {/* Address 2 */}
              <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Address 2 <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="address2"
                  type="text"
                  className="form-control "
                  style={{ fontSize: "12px" }}
                  placeholder="Apartment, suite, unit etc."
                />
                {errors.address2 && touched.address2 && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.address2}</p>
                )}
              </div>

              {/* Postal Code */}
              <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Postal Code <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="pincode"
                  type="tel"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your Pincode"
                  minLength={6}
                  maxLength={6}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9\ ]/gi, "");
                    setFieldValue("pincode", value);
                    fetchStateAndCity(value, () => {}, setFieldValue);
                  }}
                />
                {errors.pincode && touched.pincode && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.pincode}</p>
                )}
              </div>

              {/* City */}
              <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  City <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="city"
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your City"
                  readOnly={values.state && cityna !== "NA"}
                />
                {errors.city && touched.city && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.city}</p>
                )}
              </div>

              {/* State */}
              <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  State <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="state"
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Enter Your State"
                  readOnly
                />
                {errors.state && touched.state && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.state}</p>
                )}
              </div>

              {/* Country */}
              <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                  Country <span style={{ color: "red", fontSize: "13px" }}> *</span>
                </label>
                <Field
                  name="country"
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px" }}
                  placeholder="Country"
                  readOnly
                />
                <Field
                  name="countryurl"
                  type="hidden"
                  className="form-control"
                  readOnly
                />
                {errors.country && touched.country && (
                  <p style={{ color: "red", textAlign: "start" }}>{errors.country}</p>
                )}
              </div>

              {/* Form Actions */}
              <div className="form-group col-md-12 col-sm-12 col-xs-12 mt-3">
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    style={{
                      fontSize: "12px",
                      background: "#bdbfc0",
                      color: "#000",
                    }}
                    className="btn-normal btn"
                    onClick={() => setshippingaddressopen(false)}
                  >
                    Back
                  </button>
                  <button
                    type="submit"
                    style={{ fontSize: "12px", background: `#${bgColor}` }}
                    className="btn-normal btn"
                  >
                    Save 
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
                          )}
                        </div>
                      )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAddress;